export default __webpack_public_path__ + "static/media/gold.eac44207.svg";